import { ReactComponent as Monitor } from "./icons/allumer-repetiteur-scope.svg";
import { ReactComponent as IncreaseLight } from "./icons/augmenter-lumiere.svg";
import { ReactComponent as Biology } from "./icons/biologie.svg";
import { ReactComponent as ReduceLight } from "./icons/diminuer-lumiere.svg";
import { ReactComponent as TvOff } from "./icons/eteindre-la-tv.svg";
import { ReactComponent as ShutDoor } from "./icons/fermer-la-porte.svg";
import { ReactComponent as ShutBlinds } from "./icons/fermer-stores.svg";
import { ReactComponent as EmergencyRoom } from "./icons/la-chambre-des-urgences.svg";
import { ReactComponent as Hall } from "./icons/le-couloir.svg";
import { ReactComponent as Observation } from "./icons/observation-medicale.svg";
import { ReactComponent as OpenDoor } from "./icons/ouvrir-la-porte.svg";
import { ReactComponent as OpenBlinds } from "./icons/ouvrir-rideaux.svg";
import { ReactComponent as Radiology } from "./icons/radiologie.svg";
import { ReactComponent as InterviewRoom } from "./icons/salle-entretien.svg";
import { ReactComponent as Scanner } from "./icons/scanners-et-compte-rendus.svg";
import { ReactComponent as StopAlarms } from "./icons/stop-alarm-bip-telephone-portrait.svg";
import { ReactComponent as ShutCurtains } from "./icons/tirer-les-rideaux.svg";
import { ReactComponent as RectangularDesk } from "./icons/un-bureau-rectangulaire.svg";
import { ReactComponent as Computer } from "./icons/un-ordinateur.svg";
import { ReactComponent as Phone } from "./icons/un-telephone.svg";
import { ReactComponent as Tissues } from "./icons/une-boite-de-mouchoirs.svg";
import { ReactComponent as Water } from "./icons/une-carafe-d-eau-verre.svg";
import { ReactComponent as Chairs } from "./icons/une-chaise-part-et-autre-bureau.svg";
import { ReactComponent as Chair } from "./icons/une-chaise.svg";
import { ReactComponent as Drinks } from "./icons/une-desserte-pour-boissons.svg";
import { ReactComponent as Coffee } from "./icons/une-machine-a-cafe.svg";
import { ReactComponent as RoundTable } from "./icons/une-table-ronde.svg";
import { ReactComponent as Table } from "./icons/table.svg";
import { ReactComponent as NoFurniture } from "./icons/zero-meuble.svg";

interface CardContent {
  label: string,
  Icon: React.FunctionComponent,
  valid?: boolean,
  pdfLink?:string
}

const material: CardContent[] = [
  {
    label: "Un téléphone",
    Icon: () => <Phone />,
  },
  {
    label: "Salle d'entretien",
    Icon: () => <InterviewRoom/>,
    valid: true
  },
  /*{
    label: "Une table",
    Icon: () => <Table/>,
    valid: false
  },*/
  /*{
    label: "Une chaise par personne",
    Icon: () => <Chair/>,
    valid: false
  },*/
  {
    label: "Le couloir",
    Icon: () => <Hall/>
  },
  {
    label: "Une desserte pour boissons",
    Icon: () => <Drinks/>
  },
  {
    label: "Des chaises de part et d'autre du bureau",
    Icon: () => <Chairs/>,
    valid: true,
    //pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/AMNACA-PDF%20RESSOURCES%20FORMATION-22-04-15.pdf"
  },
  {
    label: "Un ordinateur",
    Icon: () => <Computer/>
  },
  /*{
    label: "Un bureau rectangulaire",
    Icon: () => <RectangularDesk/>
  },*/
  {
    label: "La chambre des urgences",
    Icon: () => <EmergencyRoom/>
  },
  {
    label: "Une machine à café",
    Icon: () => <Coffee/>,
    valid: true
  },
  {
    label: "Zéro meuble",
    Icon: () => <NoFurniture/>
  },
  {
    label: "Une boîte de mouchoirs",
    Icon: () => <Tissues/>,
    valid: true
  },
  {
    label:"Une carafe d'eau, verre...",
    Icon: () => <Water/>,
    valid: true,
    //pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/AMNACA-PDF%20RESSOURCES%20FORMATION-22-04-15.pdf"
  },
  
];

const atmosphere: CardContent[] = [
  {
    label: "Fermer la porte",
    Icon: () => <ShutDoor/>,
    valid: true,
    //pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/AMNACA-PDF%20RESSOURCES%20FORMATION-22-04-15.pdf"
  },
  {
    label: "Ouvrir la porte",
    Icon: () => <OpenDoor />
  },
  {
    label: "Allumer le répétiteur de scope",
    Icon: () => <Monitor/>
  },
  {
    label: "éteindre la télévision",
    Icon: () => <TvOff/>
  },
  {
    label: "Stopper alarmes, bips, téléphone",
    Icon: () => <StopAlarms/>,
    valid: true
  },
  {
    label: "Tirer les rideaux",
    Icon: () => <ShutCurtains/>,
    valid: true
  },
  {
    label: "Augmenter la lumière",
    Icon: () => <IncreaseLight/>
  },
  {
    label: "Fermer les stores",
    Icon: () => <ShutBlinds/>
  },
  {
    label: "Diminuer la lumière",
    Icon: () => <ReduceLight/>
  },
  {
    label: "Ouvrir les rideaux",
    Icon: () => <OpenBlinds/>
  }
]

const documents: CardContent[] = [
  {
    label: "Observation médicale",
    Icon: () => <Observation/>,
    valid: true,
    pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/CHU-AMN%20ACA-ObservationsMedicales-22-06-10.pdf"
  },
  {
    label: "Biologie",
    Icon: () => <Biology/>,
    valid: true,
    pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/CHU-AMN%20ACA-Biologie-22-06-02.pdf"
  },
  {
    label: "Radiologie du jour",
    Icon: () => <Radiology/>,
    valid: true,
    pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/CHU-AMN%20ACA-RADIO%20DU%20JOUR-22-06-02.pdf"
  },
  {
    label: "Radiologie de l'accident",
    Icon: () => <Scanner/>,
    valid: true,
    pdfLink:"https://chustorage.z13.web.core.windows.net/pdf/CHU-AMN%20ACA-RADIOS%20ACCIDENT-22-05-09.pdf"
  }
]

export {material, atmosphere, documents}


